import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };

export const blogsApi = {
  listPublic: async () => (await axios.get(`${API}/blogs`)).data,
  getPublic: async (slug) => (await axios.get(`${API}/blogs/${slug}`)).data,
  listAdmin: async () => (await axios.get(`${API}/admin/blogs`, cfg)).data,
  create: async (payload) => (await axios.post(`${API}/admin/blogs`, payload, cfg)).data,
  update: async (id, payload) => (await axios.put(`${API}/admin/blogs/${id}`, payload, cfg)).data,
  remove: async (id) => (await axios.delete(`${API}/admin/blogs/${id}`, cfg)).data,
  summarize: async (id) => (await axios.post(`${API}/admin/blogs/${id}/summarize`, {}, cfg)).data,
  publish: async (id) => (await axios.post(`${API}/admin/blogs/${id}/publish`, {}, cfg)).data,
  aiTopics: async (mode = 'both', count = 10) => (await axios.post(`${API}/admin/blogs/ai/topics`, { mode, count }, { ...cfg, timeout: 90000 })).data,
  aiGenerate: async ({ topic, length = 'seo', include_image = true }) => (await axios.post(`${API}/admin/blogs/ai/generate`, { topic, length, include_image }, { ...cfg, timeout: 180000 })).data,
  dailyTopics: async () => (await axios.get(`${API}/admin/blogs/ai/daily-topics`, cfg)).data,
  regenerateDailyTopics: async () => (await axios.post(`${API}/admin/blogs/ai/daily-topics/regenerate`, {}, { ...cfg, timeout: 90000 })).data,
  dismissDailyTopic: async (id) => (await axios.post(`${API}/admin/blogs/ai/daily-topics/${id}/dismiss`, {}, cfg)).data,
  uploadImage: async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    const { data } = await axios.post(`${API}/admin/blogs/upload`, fd, {
      ...cfg,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data; // { url, size, filename }
  },
};

export const absoluteUploadUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api/uploads/')) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};
